"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0,14.9833577 L0,6.98335775 L0.00501040141,6.98335775 L0.00833333333,1.66666667 C0.00833333333,0.75 0.75,0 1.66666667,0 L8.33333333,0 L13.3333333,5 L13.3333333,15 C13.3333333,15.9166667 12.5833333,16.6666667 11.6666667,16.6666667 L1.65833333,16.6666667 C0.741666667,16.6666667 0,15.9166667 0,15 L1.04014079e-05,14.9833577 Z M1.66666667,14.9833577 L1.66666667,15 L11.6666667,15 L11.6666667,5.83333333 L7.5,5.83333333 L7.5,1.66666667 L1.66666667,1.66666667 L1.66666667,6.98335775 L1.66666667,14.9833577 Z M1.04014079e-05,14.9833577 L1.66666667,14.9833577 L1.66666667,6.98335775 L0.00501040141,6.98335775 L1.04014079e-05,14.9833577 Z",
      id: "path-1"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "Excel",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Group-13",
      transform: "translate(2.000000, 2.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        id: "outline-insert_drive_file-24px",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          id: "Bounding_Boxes",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            id: "Shape",
            points: "0 0 20 0 20 20 0 20"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          id: "Outline",
          transform: "translate(3.333333, 1.666667)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            id: "Rectangle-6",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
              id: "mask-2",
              fill: "white",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                href: "#path-1"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
              id: "Combined-Shape",
              fill: "#417505",
              fillRule: "nonzero",
              href: "#path-1"
            })]
          })
        })]
      })
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "Group-12",
    transform: "translate(1.000000, 9.650024)",
    fill: "#417505",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2.11309814,2.15234375 L2.81036377,0.734375 L3.98516846,0.734375 L2.79278564,2.84960937 L4.01739502,5 L2.83087158,5 L2.11309814,3.55566406 L1.39532471,5 L0.211730957,5 L1.43341064,2.84960937 L0.24395752,0.734375 L1.41583252,0.734375 L2.11309814,2.15234375 Z M6.12969971,4.20898437 L7.91973877,4.20898437 L7.91973877,5 L5.10137939,5 L5.10137939,0.734375 L6.12969971,0.734375 L6.12969971,4.20898437 Z M11.3035278,3.86621094 C11.3035278,3.71581956 11.2503057,3.59863323 11.1438599,3.51464844 C11.037414,3.43066364 10.8504042,3.34375045 10.5828247,3.25390625 C10.3152452,3.16406205 10.0964974,3.07714886 9.92657471,2.99316406 C9.37383757,2.72167833 9.09747314,2.34863519 9.09747314,1.87402344 C9.09747314,1.63769413 9.16632011,1.42920012 9.30401611,1.24853516 C9.44171211,1.06787019 9.63653438,0.927246597 9.88848877,0.826660156 C10.1404432,0.726073716 10.4236434,0.67578125 10.7380981,0.67578125 C11.0447403,0.67578125 11.3196399,0.730468203 11.5628052,0.83984375 C11.8059705,0.949219297 11.9949334,1.10497946 12.1296997,1.30712891 C12.264466,1.50927835 12.3318481,1.74023308 12.3318481,2 L11.3064575,2 C11.3064575,1.82617101 11.2532354,1.69140673 11.1467896,1.59570312 C11.0403437,1.49999952 10.8963022,1.45214844 10.7146606,1.45214844 C10.531066,1.45214844 10.3860479,1.49267538 10.2796021,1.57373047 C10.1731562,1.65478556 10.1199341,1.75781187 10.1199341,1.8828125 C10.1199341,1.99218805 10.1785272,2.09130815 10.2957153,2.18017578 C10.4129034,2.26904341 10.618956,2.36083937 10.9138794,2.45556641 C11.2088027,2.55029344 11.4509878,2.6523432 11.6404419,2.76171875 C12.1013817,3.02734508 12.3318481,3.39355235 12.3318481,3.86035156 C12.3318481,4.2334003 12.1912246,4.52636612 11.9099731,4.73925781 C11.6287217,4.9521495 11.2429834,5.05859375 10.7527466,5.05859375 C10.4070417,5.05859375 10.0940566,4.99658265 9.81378174,4.87255859 C9.5335069,4.74853454 9.32257151,4.57861436 9.18096924,4.36279297 C9.03936697,4.14697158 8.96856689,3.89843891 8.96856689,3.6171875 L9.99981689,3.6171875 C9.99981689,3.84570427 10.0588983,4.01415961 10.177063,4.12255859 C10.2952276,4.23095757 10.4871203,4.28515625 10.7527466,4.28515625 C10.9226693,4.28515625 11.0569453,4.24853552 11.1555786,4.17529297 C11.2542119,4.10205042 11.3035278,3.9990241 11.3035278,3.86621094 Z",
      id: "XLS"
    })
  })]
}));